import { Injectable } from '@angular/core';
import { Store } from "@ngrx/store";
import { AppState } from "src/app/services/state/app.state";
import * as UserActions from "src/app/services/state/actions/user.action";
import * as RolesActions from "src/app/services/state/actions/roles.action";
import * as RoleLoadedActions from "src/app/services/state/actions/roleLoaded.action";
import { Roles } from 'src/app/services/state/models/roles.model';
import { TenantUserService } from 'src/app/pages/tenant/services/tenant-user.service';
import {environment} from "src/environments/environment";
import { TenantRoleService } from 'src/app/pages/tenant/services/tenant-role.service';

@Injectable({
  providedIn: 'root'
})
export class StateService {

  constructor(private store:Store<AppState>,private tenantUserService:TenantUserService,private tenantRoleService:TenantRoleService) { }


  async loadUserInfo() {
    //检测是否加载完成Role接口
    this.store.dispatch(new RoleLoadedActions.SetRoleLoaded(false))

    this.store.dispatch(new RolesActions.ClearRole())

    if (!environment.isAdmin) {
      const res = await this.tenantUserService.getCurrentUserInfo().toPromise();
      let currentUser = res['data'];
      this.store.dispatch(new UserActions.SetUser(currentUser));
      //加载用户权限
      if(currentUser.userRoles?.length>0){
        let promiseArr:any[] =  [];
        //用户下有多个权限
        currentUser.userRoles.forEach(o=>{
          promiseArr.push(this.tenantRoleService.searchById(o.roleId).toPromise())
        })
        let res = await Promise.all(promiseArr)
        res.forEach((o:Roles)=>{
          this.store.dispatch(new RolesActions.AddRole(o))
        })

        this.store.dispatch(new RoleLoadedActions.SetRoleLoaded(true))
      }
    }
    return true;
  }
}
